// extracted by mini-css-extract-plugin
export default {"card":"Card_card__df6FJ","card__cardIcon":"Card_card__cardIcon__iby9c","card__cardText":"Card_card__cardText__SH+No"};